import Mutations from '../../odata/mutations';

export default { ...new Mutations('contractSection'), ...new Mutations('contractSections') };
